import { ClientPointEvent, ContainerElement, pointer } from 'd3-selection';
import React from 'react';
import { Scale } from '../types/scale';
import { useStrip } from './useStrip';

export const useEventVoltage = () => {
  const { yScale } = useStrip();

  return (event: React.MouseEvent<ContainerElement>) =>
    toVoltage(yScale, event.currentTarget, event);
};

const toVoltage = (
  yScale: Scale,
  target: ContainerElement,
  event: ClientPointEvent,
): number => yScale.invert(pointer(event, target)[1]);
